<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 class="label-black" style="margin-bottom: 0px;">Reportes</h5>
            <h6 class="label-black" style="margin-top: 0px;">Reporte de Solicitudes de la Áreas en Archivo Judicial</h6>
        </div>

        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;" >
                <div class="area custom-area">
                    
                    <div > 
                        <div class="form-group" id="solicitud_div">
                            <label class="label-black">Fecha de Solicitudes:</label>
                            <input class="form-control" type="month"  v-model="Busqueda.Fecha"/>
                        </div>
                        
                        <div id="BotonBusqueda_div" class="text-right">
                            <button class="btn btn-custom"  @click='BuscaFecha()'>Obtener Estadístico</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="ListadoSolicitudes.length>0">
                <div class="area custom-area">
                    <div>
                        <h6 class="label-black">Listado de Solicitudes en {{this.EtiquetaFecha}} registradas en la Dirección del Archivo Judicial</h6>
                    </div>
                    <div v-if="Todos==0" class="col-4">
                        
                        <sedes v-on:valorParaElPadre="cambioDeSede" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'filtroDeBusqueda_Area'" 
                                :parametros="parametros_SedeArchivo" 
                                :valorDefinido="parametros_SedeArchivo.sedeArchivoId" 
                                :key="parametros_SedeArchivo.sedeArchivoId"
                            ></sedes>
                    </div>
                    <div id="solicitudes_table" class="table-responsive" v-if="ListadoEstadistico.length>0">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                                <tr v-for="hListadoEstadistico in TableHeader">
                                    <th>Area</th>
                                    <!-- <th>Estatus</th> -->
                                    <th v-if="hListadoEstadistico.Dia01 !=null">01</th>
                                    <th v-if="hListadoEstadistico.Dia02 !=null">02</th>
                                    <th v-if="hListadoEstadistico.Dia03 !=null">03</th>
                                    <th v-if="hListadoEstadistico.Dia04 !=null">04</th>
                                    <th v-if="hListadoEstadistico.Dia05 !=null">05</th>
                                    <th v-if="hListadoEstadistico.Dia06 !=null">06</th>
                                    <th v-if="hListadoEstadistico.Dia07 !=null">07</th>
                                    <th v-if="hListadoEstadistico.Dia08 !=null">08</th>
                                    <th v-if="hListadoEstadistico.Dia09 !=null">09</th>
                                    <th v-if="hListadoEstadistico.Dia10 !=null">10</th>
                                    <th v-if="hListadoEstadistico.Dia11 !=null">11</th>
                                    <th v-if="hListadoEstadistico.Dia12 !=null">12</th>
                                    <th v-if="hListadoEstadistico.Dia13 !=null">13</th>
                                    <th v-if="hListadoEstadistico.Dia14 !=null">14</th>
                                    <th v-if="hListadoEstadistico.Dia15 !=null">15</th>
                                    <th v-if="hListadoEstadistico.Dia16 !=null">16</th>
                                    <th v-if="hListadoEstadistico.Dia17 !=null">17</th>
                                    <th v-if="hListadoEstadistico.Dia18 !=null">18</th>
                                    <th v-if="hListadoEstadistico.Dia19 !=null">19</th>
                                    <th v-if="hListadoEstadistico.Dia20 !=null">20</th>
                                    <th v-if="hListadoEstadistico.Dia21 !=null">21</th>
                                    <th v-if="hListadoEstadistico.Dia22 !=null">22</th>
                                    <th v-if="hListadoEstadistico.Dia23 !=null">23</th>
                                    <th v-if="hListadoEstadistico.Dia24 !=null">24</th>
                                    <th v-if="hListadoEstadistico.Dia25 !=null">25</th>
                                    <th v-if="hListadoEstadistico.Dia26 !=null">26</th>
                                    <th v-if="hListadoEstadistico.Dia27 !=null">27</th>
                                    <th v-if="hListadoEstadistico.Dia28 !=null">28</th>
                                    <th v-if="hListadoEstadistico.Dia29 !=null">29</th>
                                    <th v-if="hListadoEstadistico.Dia30 !=null">30</th>
                                    <th v-if="hListadoEstadistico.Dia31 !=null">31</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListadoEstadistico">
                                <tr>
                                    <td rowspan="5" >{{Lista.Area.Nombre}}</td>
                                </tr>
                                <tr v-for="solicitudes in Lista.Solicitudes" >
                                    <!-- <td>{{solicitudes.Tipo}}</td> -->
                                    <td v-if="solicitudes.Dia01!=null">{{solicitudes.Dia01}} </td>
                                    <td v-if="solicitudes.Dia02!=null">{{solicitudes.Dia02}} </td>
                                    <td v-if="solicitudes.Dia03!=null">{{solicitudes.Dia03}} </td>
                                    <td v-if="solicitudes.Dia04!=null">{{solicitudes.Dia04}} </td>
                                    <td v-if="solicitudes.Dia05!=null">{{solicitudes.Dia05}} </td>
                                    <td v-if="solicitudes.Dia06!=null">{{solicitudes.Dia06}} </td>
                                    <td v-if="solicitudes.Dia07!=null">{{solicitudes.Dia07}} </td>
                                    <td v-if="solicitudes.Dia08!=null">{{solicitudes.Dia08}} </td>
                                    <td v-if="solicitudes.Dia09!=null">{{solicitudes.Dia09}} </td>
                                    <td v-if="solicitudes.Dia10!=null">{{solicitudes.Dia10}} </td>
                                    <td v-if="solicitudes.Dia11!=null">{{solicitudes.Dia11}} </td>
                                    <td v-if="solicitudes.Dia12!=null">{{solicitudes.Dia12}} </td>
                                    <td v-if="solicitudes.Dia13!=null">{{solicitudes.Dia13}} </td>
                                    <td v-if="solicitudes.Dia14!=null">{{solicitudes.Dia14}} </td>
                                    <td v-if="solicitudes.Dia15!=null">{{solicitudes.Dia15}} </td>
                                    <td v-if="solicitudes.Dia16!=null">{{solicitudes.Dia16}} </td>
                                    <td v-if="solicitudes.Dia17!=null">{{solicitudes.Dia17}} </td>
                                    <td v-if="solicitudes.Dia18!=null">{{solicitudes.Dia18}} </td>
                                    <td v-if="solicitudes.Dia19!=null">{{solicitudes.Dia19}} </td>
                                    <td v-if="solicitudes.Dia20!=null">{{solicitudes.Dia20}} </td>
                                    <td v-if="solicitudes.Dia21!=null">{{solicitudes.Dia21}} </td>
                                    <td v-if="solicitudes.Dia22!=null">{{solicitudes.Dia22}} </td>
                                    <td v-if="solicitudes.Dia23!=null">{{solicitudes.Dia23}} </td>
                                    <td v-if="solicitudes.Dia24!=null">{{solicitudes.Dia24}} </td>
                                    <td v-if="solicitudes.Dia25!=null">{{solicitudes.Dia25}} </td>
                                    <td v-if="solicitudes.Dia26!=null">{{solicitudes.Dia26}} </td>
                                    <td v-if="solicitudes.Dia27!=null">{{solicitudes.Dia27}} </td>
                                    <td v-if="solicitudes.Dia28!=null">{{solicitudes.Dia28}} </td>
                                    <td v-if="solicitudes.Dia29!=null">{{solicitudes.Dia29}} </td>
                                    <td v-if="solicitudes.Dia30!=null">{{solicitudes.Dia30}} </td>
                                    <td v-if="solicitudes.Dia31!=null">{{solicitudes.Dia31}} </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>{{this.Totales.Total}}</td>
                                    <!-- <td></td> -->
                                    <td v-if="Totales.Dia01!=0">{{this.Totales.Dia01}}</td>
                                    <td v-if="Totales.Dia02!=0">{{this.Totales.Dia02}}</td>
                                    <td v-if="Totales.Dia03!=0">{{this.Totales.Dia03}}</td>
                                    <td v-if="Totales.Dia04!=0">{{this.Totales.Dia04}}</td>
                                    <td v-if="Totales.Dia05!=0">{{this.Totales.Dia05}}</td>
                                    <td v-if="Totales.Dia06!=0">{{this.Totales.Dia06}}</td>
                                    <td v-if="Totales.Dia07!=0">{{this.Totales.Dia07}}</td>
                                    <td v-if="Totales.Dia08!=0">{{this.Totales.Dia08}}</td>
                                    <td v-if="Totales.Dia09!=0">{{this.Totales.Dia09}}</td>
                                    <td v-if="Totales.Dia10!=0">{{this.Totales.Dia10}}</td>
                                    <td v-if="Totales.Dia11!=0">{{this.Totales.Dia11}}</td>
                                    <td v-if="Totales.Dia12!=0">{{this.Totales.Dia12}}</td>
                                    <td v-if="Totales.Dia13!=0">{{this.Totales.Dia13}}</td>
                                    <td v-if="Totales.Dia14!=0">{{this.Totales.Dia14}}</td>
                                    <td v-if="Totales.Dia15!=0">{{this.Totales.Dia15}}</td>
                                    <td v-if="Totales.Dia16!=0">{{this.Totales.Dia16}}</td>
                                    <td v-if="Totales.Dia17!=0">{{this.Totales.Dia17}}</td>
                                    <td v-if="Totales.Dia18!=0">{{this.Totales.Dia18}}</td>
                                    <td v-if="Totales.Dia19!=0">{{this.Totales.Dia19}}</td>
                                    <td v-if="Totales.Dia20!=0">{{this.Totales.Dia20}}</td>
                                    <td v-if="Totales.Dia21!=0">{{this.Totales.Dia21}}</td>
                                    <td v-if="Totales.Dia22!=0">{{this.Totales.Dia22}}</td>
                                    <td v-if="Totales.Dia23!=0">{{this.Totales.Dia23}}</td>
                                    <td v-if="Totales.Dia24!=0">{{this.Totales.Dia24}}</td>
                                    <td v-if="Totales.Dia25!=0">{{this.Totales.Dia25}}</td>
                                    <td v-if="Totales.Dia26!=0">{{this.Totales.Dia26}}</td>
                                    <td v-if="Totales.Dia27!=0">{{this.Totales.Dia27}}</td>
                                    <td v-if="Totales.Dia28!=0">{{this.Totales.Dia28}}</td>
                                    <td v-if="Totales.Dia29!=0">{{this.Totales.Dia29}}</td>
                                    <td v-if="Totales.Dia30!=0">{{this.Totales.Dia30}}</td>
                                    <td v-if="Totales.Dia31!=0">{{this.Totales.Dia31}}</td>
                                </tr>
                                <tr>
                                    <td><strong>Gran Total</strong></td>
                                    <td v-if="Totales.ConteoTotal!=0"><strong>{{this.Totales.ConteoTotal}}</strong></td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                    
                    <div class="text-left" v-if="ListadoEstadistico.length>0">
                            <button class="btn btn-sm btn-custom" @click='ImprimirListado(parametros_SedeArchivo)' >Imprimir Listado</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
 
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'
export default {
    components : {
        sedes : catalogos.ArchivoJudicial.C012SedesArchivo
    },
    data(){
        return{
            enumeraciones,
            Busqueda:{
                Fecha: moment().format('YYYY-MM'),
            },
            ListadoSolicitudes :[],
            AreaEtiqueta:"",
            EtiquetaFecha: "",
            ListadoEstadistico: [],
            TableHeader: [],
            Totales: {
                Total: "Total",
                Dia01: 0,
                Dia02: 0,
                Dia03: 0,
                Dia04: 0,
                Dia05: 0,
                Dia06: 0,
                Dia07: 0,
                Dia08: 0,
                Dia09: 0,
                Dia10: 0,
                Dia11: 0,
                Dia12: 0,
                Dia13: 0,
                Dia14: 0,
                Dia15: 0,
                Dia16: 0,
                Dia17: 0,
                Dia18: 0,
                Dia19: 0,
                Dia20: 0,
                Dia21: 0,
                Dia22: 0,
                Dia23: 0,
                Dia24: 0,
                Dia25: 0,
                Dia26: 0,
                Dia27: 0,
                Dia28: 0,
                Dia29: 0,
                Dia30: 0,
                Dia31: 0,
                ConteoTotal:0
            },
            Todos: -1,
            parametros_SedeArchivo:{
                sedeArchivoId: -1,
                Nombre: ""
            }, 
        }
    },
    methods: {
        
        LimpiaBusqueda (){
            this.Busqueda.Fecha= null;
        },
        ValidaBusquedaFecha(){
            if (this.Busqueda.Fecha == null)
            {
                comun.mensajeDeAlerta("Determine un Periodo Correcto", null, null);
                return false;
            };
            if(this.Busqueda.Fecha>moment().format('YYYY-MM'))
            {
                comun.mensajeDeAlerta("El Perdiodo para consulta no puede ser mayor al mes corriente", null, null);
                return false;
            }

            return true;
        },
        BuscaFecha(){
           if(this.ValidaBusquedaFecha ()== true)
           {
                   // Obtencion de Listado
                   this.TableHeader = [];
                   var peticion = {
                    "FechaListado": this.Busqueda.Fecha,
                        };
                    //this.AreaEtiqueta = this.Busqueda.parametros_Area.Nombre;
                    this.EtiquetaFecha = this.ObtieneMesLetra(this.Busqueda.Fecha);
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.ReporteJuzgadosEnArchivo, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                        {
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            this.LimpiaBusqueda();
                        }
                    else
                        {   
                            comun.SeEstaCargandoInformacion(false);
                            console.log(respuesta.data.Solicitudes)
                            this.ListadoSolicitudes= respuesta.data.Solicitudes;
                            this.Todos = respuesta.data.sedeId;
                            //var Sedes =respuesta.data.TodasSedes;
                            if (this.ListadoSolicitudes.length==0)
                            {
                                comun.mensajeDeAlerta("No hay solicitudes en fecha seleccionada", null, null);
                            }
                            else
                            {
                                this.FormatoDatos(this.ListadoSolicitudes);
                            }
                            this.AreaFecha = true;
                            this.AreaSolicitud = false;
                        }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros ", excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                        });
           };
            this.AreaSolicitud = false,
            this.AreaFecha= true; 
           
        },
        FormatoDatos(datos)
        {   
            this.LimpiaObjeto();
                       
            let header = {"Area": "Area","Estatus": "Estatus"}
            let totales = {"Totales": "Totales"};
            let TempHeader = {};
            var ListaPreliminar =[];
            var ListadoDeDias=[];
            var ListaSecundaria = [];
            
            var TotalTemporal = Object.assign(this.Totales);
            $.each(datos, function(index, listado)
            {
                var PorArea = ListaPreliminar.find(e=>e.Area.AreaId == listado.InventarioDocumentos.Area.AreaId);
                if(PorArea == undefined || PorArea == false)
                {
                    ListaPreliminar.push(
                        {
                            "Area": listado.InventarioDocumentos.Area,
                            "AreaId":listado.InventarioDocumentos.Area.AreaId,
                            "MateriaId": listado.InventarioDocumentos.Materia.MateriaId,
                            "Solicitudes": [{
                                "SolicitudDocumentoId": listado.SolicitudDocumentoId,
                                //"TipoEstatusSolicitud" : listado.TipoEstatusSolicitud,
                                "FechaRegistro": listado.FechaRegistro
                            }]
                        });
                }
                else
                {
                    PorArea.Solicitudes.push(
                        {
                            "SolicitudDocumentoId": listado.SolicitudDocumentoId,
                            //"TipoEstatusSolicitud" : listado.TipoEstatusSolicitud,
                            "FechaRegistro": listado.FechaRegistro
                        });
                };
                
                
                var porDia = ListadoDeDias.find(e=>e.Dia == moment(listado.FechaRegistro).format('DD'));
                if(porDia == undefined || porDia==false)
                {
                    ListadoDeDias.push({"Dia": moment(listado.FechaRegistro).format('DD')});
                    TempHeader = Object.assign(header, {["Dia" +  moment(listado.FechaRegistro).format('DD') ]: moment(listado.FechaRegistro).format('DD')})
                };

            })
            
            $.each(ListaPreliminar, function(index, listado)
            {
                var porTipo = ListaSecundaria.find(e=>e.Area.AreaId == listado.Area.AreaId);
                if(porTipo==undefined || porTipo==false)
                {   
                    var conteoTipoTerminadas =[];
                    var conteoTipoCanceladas = [];
                    var conteoEnSolicitud= [];
                    var conteoEnPrestamo = [];
                    var Area = listado.Area;
                    var areaId = listado.AreaId;
                    var materia = listado.MateriaId;
                    var Tempo1 ={};
                    var Tempo2 ={};
                    var Tempo3 ={};
                    var Tempo4 ={};
                    var conteo1=0;
                    var ConteoTotal = 0;
                    
                    var Solicitud = {"Tipo": "Solicitud"};
                    // var Prestamo ={"Tipo": "Prestamo"};
                    // var Terminadas = {"Tipo": "Terminado"};
                    // var Canceladas ={"Tipo": "Canceladas"};
                        $.each(ListadoDeDias, function (index,dias)
                        {
                            conteoEnSolicitud = listado.Solicitudes.filter(a=> moment(a.FechaRegistro).format('DD')==dias.Dia);
                            // conteoEnPrestamo = listado.Solicitudes.filter(a=>a.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId == 2 && moment(a.FechaRegistro).format('DD')==dias.Dia);
                            // conteoTipoTerminadas = listado.Solicitudes.filter(a=>a.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId == 4 && moment(a.FechaRegistro).format('DD')==dias.Dia);
                            // conteoTipoCanceladas = listado.Solicitudes.filter(a=>a.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId == 5 && moment(a.FechaRegistro).format('DD')==dias.Dia);

                            Tempo1= Object.assign(Solicitud, {["Dia" + dias.Dia]: conteoEnSolicitud.length});
                            // Tempo2 = Object.assign(Prestamo, {["Dia" + dias.Dia]: conteoEnPrestamo.length});
                            // Tempo3= Object.assign(Terminadas, {["Dia" + dias.Dia]: conteoTipoTerminadas.length});
                            // Tempo4 = Object.assign(Canceladas, {["Dia" + dias.Dia]: conteoTipoCanceladas.length});
                            conteo1= conteoEnSolicitud.length + conteoEnPrestamo.length + conteoTipoTerminadas.length +conteoTipoCanceladas.length;
                            TotalTemporal.ConteoTotal +=conteo1;
                            switch(parseInt(dias.Dia))
                                {
                                    case 1:
                                        TotalTemporal.Dia01 += conteo1;
                                        break;
                                    case 2:
                                        TotalTemporal.Dia02 += conteo1;
                                        break;
                                    case 3:
                                        TotalTemporal.Dia03  += conteo1;
                                        break;
                                    case 4:
                                        TotalTemporal.Dia04 += conteo1;
                                        break;
                                    case 5:
                                        TotalTemporal.Dia05 += conteo1;
                                        break;
                                    case 6:
                                        TotalTemporal.Dia06 += conteo1;
                                        break;
                                    case 7:
                                        TotalTemporal.Dia07 += conteo1;
                                        break;
                                    case 8:
                                        TotalTemporal.Dia08 += conteo1;
                                        break;
                                    case 9:
                                        TotalTemporal.Dia09 += conteo1;
                                        break;
                                    case 10:
                                        TotalTemporal.Dia10 += conteo1;
                                        break;
                                    case 11:
                                        TotalTemporal.Dia11 += conteo1;
                                        break;
                                    case 12:
                                        TotalTemporal.Dia12 += conteo1;
                                        break;
                                    case 13:
                                        TotalTemporal.Dia13 += conteo1;
                                        break;
                                    case 14:
                                        TotalTemporal.Dia14 += conteo1;
                                        break;
                                    case 15:
                                        TotalTemporal.Dia15 += conteo1;
                                        break;
                                    case 16:
                                        TotalTemporal.Dia16 += conteo1;
                                        break;
                                    case 17:
                                        TotalTemporal.Dia17 += conteo1;
                                        break;
                                    case 18:
                                        TotalTemporal.Dia18 += conteo1;
                                        break;
                                    case 19:
                                        TotalTemporal.Dia19 += conteo1;
                                        break;
                                    case 20:
                                        TotalTemporal.Dia20 += conteo1;
                                        break;
                                    case 21:
                                        TotalTemporal.Dia21 += conteo1;
                                        break;
                                    case 22:
                                        TotalTemporal.Dia22 += conteo1;
                                        break;
                                    case 23:
                                        TotalTemporal.Dia23 += conteo1;
                                        break;
                                    case 24:
                                        TotalTemporal.Dia24 += conteo1;
                                        break;
                                    case 25:
                                        TotalTemporal.Dia25 += conteo1;
                                        break;
                                    case 26:
                                        TotalTemporal.Dia26 += conteo1;
                                        break;
                                    case 27:
                                        TotalTemporal.Dia27 += conteo1;
                                        break;
                                    case 28:
                                        TotalTemporal.Dia28 += conteo1;
                                        break;
                                    case 29:
                                        TotalTemporal.Dia29 += conteo1;
                                        break;
                                    case 30:
                                        TotalTemporal.Dia30 += conteo1;
                                        break;
                                    case 31:
                                        TotalTemporal.Dia31 += conteo1;
                                        break;
                                }
                        });
                    
                    ListaSecundaria.push({
                        Area,
                        areaId, 
                        materia,
                        "Solicitudes": [Tempo1]
                    });
                    var i= ListaSecundaria.length -1;
                    ListaSecundaria[i].Solicitudes.push(Tempo2);
                    ListaSecundaria[i].Solicitudes.push(Tempo3);
                    ListaSecundaria[i].Solicitudes.push(Tempo4);
                }
            });
            
            this.TableHeader.push(TempHeader);
            this.ListadoEstadistico = ListaSecundaria.sort(this.sortMateriasAreas);//(a,b)=>(a.materia>b.materia?1:-1) && (a.Area.AreaId>b.Area.AreaId?1:-1));;
            
            TotalTemporal = null;
            
        },
        ImprimirListado(sede){
            let etiquetaSede ='';
            if(sede.sedeArchivoId>0)
            {
                etiquetaSede = 'SEDE DE ARCHIVO: ' + sede.Nombre;
            }
            else
            {
                etiquetaSede =''
            }
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES DE LOS JUZGADOS REGISTRADAS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">SOLICITUDES EN '+ this.EtiquetaFecha.toUpperCase() +'</h6>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">'+ etiquetaSede.toUpperCase() +'</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            
            printWin.document.write('</div>');
            printWin.document.write('<div class="area">');
            
           
            var areaImpresion = document.getElementById('solicitudes_table').innerHTML;
            printWin.document.write(areaImpresion);
            
           
            printWin.document.write('</div>');
 
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ObtieneMesLetra(fecha){
            var mes= "";
            var anio = moment(fecha).format('YYYY');
            switch (parseInt(moment(fecha).format('MM')))
            {
                case 1:
                    mes = "Enero";
                    break;
                case 2:
                    mes = "Febrero";
                    break;
                case 3:
                    mes = "Marzo";
                    break;
                case 4:
                    mes = "Abril";
                    break;
                case 5:
                    mes = "Mayo";
                    break;
                case 6:
                    mes = "Junio";
                    break;
                case 7:
                    mes = "Julio";
                    break;
                case 8:
                    mes = "Agosto";
                    break;
                case 9:
                    mes = "Septiembre";
                    break;
                case 10:
                    mes = "Octubre";
                    break;
                case 11:
                    mes = "Noviembre";
                    break;
                case 12:
                    mes = "Diciembre";
                    break;
            }
            return (mes + " del " + anio)
        }, 
        LimpiaObjeto(){
            this.Totales.Dia01=0;
            this.Totales.Dia02=0;
            this.Totales.Dia03=0;
            this.Totales.Dia04=0;
            this.Totales.Dia05=0;
            this.Totales.Dia06=0;
            this.Totales.Dia07=0;
            this.Totales.Dia08=0;
            this.Totales.Dia09=0;
            this.Totales.Dia10=0;
            this.Totales.Dia11=0;
            this.Totales.Dia12=0;
            this.Totales.Dia13=0;
            this.Totales.Dia14=0;
            this.Totales.Dia15=0;
            this.Totales.Dia16=0;
            this.Totales.Dia17=0;
            this.Totales.Dia18=0;
            this.Totales.Dia19=0;
            this.Totales.Dia20=0;
            this.Totales.Dia21=0;
            this.Totales.Dia22=0;
            this.Totales.Dia23=0;
            this.Totales.Dia24=0;
            this.Totales.Dia25=0;
            this.Totales.Dia26=0;
            this.Totales.Dia27=0;
            this.Totales.Dia28=0;
            this.Totales.Dia29=0;
            this.Totales.Dia30=0;
            this.Totales.Dia31=0;
            this.Totales.ConteoTotal = 0;
        },
        cambioDeSede(datos){
            this.parametros_SedeArchivo.sedeArchivoId = parseInt(datos.target.value);
            this.parametros_SedeArchivo.Nombre = datos.target.selectedOptions[0].text;
            this.ListadoEstadistico=[];
            this.TableHeader = [];
            let array = [];
            if(this.parametros_SedeArchivo.sedeArchivoId>0)
            {
                array = this.ListadoSolicitudes.filter(e=>e.InventarioDocumentos.SedeArchivo.SedeArchivoId==this.parametros_SedeArchivo.sedeArchivoId);
            }
            else
            {
                array =this.ListadoSolicitudes;
            }
            this.FormatoDatos(array);
        },
        sortMateriasAreas: function (a,b)
        {
            if(a.materia < b.materia) return -1
            if(a.materia > b.materia) return 1
            if(a.areaId < b.areaId) return -1
            if(a.areaId > b.areaId) return 1
            return 0
        }
    }
}
</script>
<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>




// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Reportes/JuzgadoEnArchivo.vue